export const Role = {
  user: "ROLE_USER",
  admin: "ROLE_ADMIN",
  owner: "ROLE_OWNER",
};
